import "aos/dist/aos.css";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/css";
import "swiper/css/pagination";
import "./App.scss";

import AOS from "aos";
import { useEffect } from "react";
import BackToTopButton from "./components/BackToTopButton";
import Banner from "./components/Banner";
import CarbonProducts from "./components/CarbonProducts";
import Faq from "./components/Faq";
import Feature from "./components/Feature";
import Footer from "./components/Footer";
import Header from "./components/Header";
import OurTeam from "./components/OurTeam";
import Panel from "./components/Panel";
import Reviews from "./components/Reviews";

function App() {
  const Wrapper = ({ children }) => {
    const location = window.location;
    useEffect(() => {
      setTimeout(() => {
        document.documentElement.scrollTo(0, 0);
      }, 0);
    }, [location.pathname, location.search]);
    return children;
  };

  useEffect(() => {
    AOS.init({
      once: true,
      easing: "ease-out-cubic",
      offset: 0,
      duration: 1200,
      delay: 100,
    });
  }, []);

  return (
    <Wrapper>
      <Header />
      <Banner />
      <Panel />
      <Feature />
      <Faq />
      <CarbonProducts />
      <Reviews />
      <OurTeam />
      <Footer />
      <BackToTopButton />
    </Wrapper>
  );
}

export default App;
